import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const { default: ImageComponent } = require('shared/ImageComponent');
const { openLinkInBlank, toPascalCase, formatNumbersToCurrencyString } = require('utils/utils');
const _ = require('lodash');

export const nameBody = (rowData) => {
  let title = [rowData.first_name, rowData.middle_name, rowData.last_name].filter((index) => index !== undefined);

  return (
    <>
      <span className="p-column-title">Name</span>
      <div className="text-primary-main  pointer" style={{ color: '#517DDA' }}>
        <Link
          className="d-flex gap-2"
          to={() => {
            let id = rowData.contact_id ? rowData.contact_id : rowData.firm_user_id;
            if (!openLinkInBlank(`/settings/team-management/${id}`)) {
              return `/settings/team-management/${id}`;
            }

            return `/settings/team-management/${id}`;
          }}
          onClick={(e) => {
            localStorage.setItem('sk', rowData.sk);
            localStorage.setItem('pk', rowData.pk);
          }}
          state={rowData}
        >
          <ImageComponent filePath={rowData && rowData.profile_image} fileName={rowData && rowData.first_name} fileSize="small.jpg" />
          <span
            className="text-primary-dark text-bold pointer"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '180px',
            }}
            title={title.join(' ')}
          >
            {title.join(' ')}
          </span>
        </Link>
        <div> {'is_confirmed' in rowData && rowData.is_confirmed === false ? <i style={{ marginLeft: '2rem' }}>Invited </i> : null}</div>
      </div>
    </>
  );
};

export const rateBody = (rowData) => {
  return (
    <>
      <span className="p-column-title">Rate</span>
      <span className="" title={formatNumbersToCurrencyString(rowData?.rate)}>
        {formatNumbersToCurrencyString(rowData?.rate)}
      </span>
    </>
  );
};

const roleLabel = (rowData) => {
  if (rowData && rowData.access_level === 'firm-admin') {
    return 'Firm Admin';
  } else if (rowData.user_type) {
    return _.startCase(_.toLower(rowData._user_type_));
  }
};

export const roleBody = (rowData) => {
  return (
    <>
      <span className="p-column-title">Role</span>
      <span className="" title={roleLabel(rowData)}>
        {roleLabel(rowData)}
      </span>
    </>
  );
};

export const groupBody = (rowData, setRemaininggroupsData, overlayPanelRef) => {
  const sanitizedPk = rowData?.pk.replace(/[^a-zA-Z0-9_-]/g, '_');

  let parsedUserGroups = [];
  try {
    if (typeof rowData?.user_group === 'string') {
      parsedUserGroups = JSON.parse(rowData?.user_group);
    } else if (Array.isArray(rowData?.user_group)) {
      parsedUserGroups = rowData?.user_group;
    }
  } catch (e) {
    console.error('Failed to parse user_group:', e);
  }

  const userGroupsArr = parsedUserGroups?.length > 0 ? parsedUserGroups?.map((item) => item?.group_name) : [];
  const displayedGroups = userGroupsArr?.slice(0, 1);
  const remainingGroups = userGroupsArr?.slice(1);

  const handleMoreClick = (e) => {
    setRemaininggroupsData(remainingGroups);
    overlayPanelRef?.current?.toggle(e);
  };
  return (
    <>
      <span className="p-column-title">Groups</span>
      <Link
        className="redirection-link-no-text-transform groups-redirection"
        to={() => {
          const route = '/settings/groups';
          if (!openLinkInBlank(route)) {
            return route;
          }
        }}
        title={displayedGroups[0]}
      >
        {/* {userGroupsArr?.join()} */}
        {displayedGroups[0]}
      </Link>
      {remainingGroups?.length > 0 && (
        <div className="position-relative">
          <Button
            className={`p-mr-2 pa-tags more-tag-button more-tag-${sanitizedPk}`}
            label={`+${remainingGroups?.length} more`}
            onClick={handleMoreClick}
            style={{ padding: '5px 10px' }}
          />
        </div>
      )}
    </>
  );
};

export const tableCell = (row, ...rest) => {
  const { header, field } = rest?.[0];
  let string = row?.[field];
  return (
    <>
      <span className="p-column-title">{header}</span>
      {typeof string === 'string' ? (
        <span className="" title={toPascalCase(string)}>
          {toPascalCase(string)}
        </span>
      ) : (
        <span></span>
      )}
    </>
  );
};
export const statusBody = (rowData) => {
  return (
    <>
      <span className="p-column-title">Status</span>
      <span title={rowData.is_confirmed ? 'Confirmed' : 'Pending'} className="status-tags">
        <Tag
          className={rowData?.is_confirmed ? 's-tag file-manager-ellipsis-text' : 'd-tag file-manager-ellipsis-text'}
          value={rowData.is_confirmed ? 'Confirmed' : 'Pending'}
          severity="success"
        ></Tag>
      </span>
    </>
  );
};
